import React, { Component } from "react";
import NavigationLink from "components/Layout/Navigation/NavigationLink";
import { toggleMenu } from "helpers/Helpers";
import { I18n } from "react-i18next";
import i18n from "../../../i18n";
import Language from "components/Layout/Navigation/Language";

export default class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = { isToggleOn: true };

    // This binding is necessary to make `this` work in the callback
    this.handleClick = this.handleClick.bind(this);
    this.menuActive = this.menuActive.bind(this);
  }

  menuActive(value) {
    const menuModal = document.getElementById("navigation__Modal");

    if (value == true) {
      menuModal.classList.add("navigation__Modal--active");
    } else {
      menuModal.classList.remove("navigation__Modal--active");
    }
  }

  handleClick() {
    this.setState((prevState) => ({
      isToggleOn: !prevState.isToggleOn,
    }));
    this.menuActive(this.state.isToggleOn);
  }

  render() {
    return (
      <I18n>
        {(t, { i18n }) => (
          <nav className="navigation flex mt30">
            <NavigationLink
              to="/"
              onClick={(e) => toggleMenu("mb-nav-wrapper")}
            >
              {t("navHome")}
            </NavigationLink>
            <NavigationLink
              to="/over-fpg"
              onClick={(e) => toggleMenu("mb-nav-wrapper")}
            >
              {t("navAbout")}
            </NavigationLink>
            <NavigationLink
              to="/assortiment"
              onClick={(e) => toggleMenu("mb-nav-wrapper")}
            >
              {t("navAssort")}
            </NavigationLink>
            <NavigationLink
              to="/vacatures"
              onClick={(e) => toggleMenu("mb-nav-wrapper")}
            >
              {t("navEducation")}
            </NavigationLink>
            <NavigationLink
              to="/duurzaamheid"
              onClick={(e) => toggleMenu("mb-nav-wrapper")}
            >
              {t("navSustainable")}
            </NavigationLink>
            <NavigationLink
              to="/blog"
              onClick={(e) => toggleMenu("mb-nav-wrapper")}
            >
              {t("navBlog")}
            </NavigationLink>
            <NavigationLink
              to="/contact"
              onClick={(e) => toggleMenu("mb-nav-wrapper")}
            >
              {t("navContact")}
            </NavigationLink>
            <Language />
          </nav>
        )}
      </I18n>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Navigation/Navigation.jsx